<template>
  <div class="trails">
    <vue-headful :title="page.fields.seo.seo_title" :description="page.fields.seo.meta_description" url="https://alabama.travel/trails" />
    <Banner
      class="hero-image"
      :bannerId="page.fields.hero.hero_image"
      type="image"
      :description="page.fields.hero.hero_description"
      :imageAlt="page.fields.hero_image_alt_text"
      :location="page.fields.hero.hero_location"
      :link="page.fields.hero.hero_link"
    />
    <section>
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h1 class="mt-5">{{ this.page.fields.paragraph_header }}</h1>
            <p class="text-left">{{ this.page.fields.paragraph }}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 mb-4" v-for="(trail, index) in trails" :key="index">
            <router-link :to="`/trail-details/${trail.slug}`" class="trails-card">
              <figure class="trails-figure">
                <img :src="trail.image" class="img-fluid" />
              </figure>
              <div class="card-trails">
                <h3 class="trails-hd">{{ trail.name }}</h3>
                <span>{{ trail.summary }}</span>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <Feedback pageType="page" />
    <Footer />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import Butter from 'buttercms';
import Footer from '@/components/Common/Footer.vue';
import Banner from '@/components/Common/Banner.vue';

export const butter = Butter('eb418357164849860c223876bb84811162582149');

@Component({
  data() {
    return {
      page: {
        fields: {
          seo: {},
          hero: {},
        },
      },
      trails: [],
      trailsFromButter: [],
    };
  },
  components: {
    Footer,
    Banner,
  },
  methods: {
    getPages() {
      butter.page
        .retrieve('*', 'trails-main', { preview: `${process.env.VUE_APP_BUTTER_PREVIEW}` })
        .then((res) => {
          this.page = res.data.data;
        })
        .catch((res) => {
          console.log(res);
        });

      butter.page
        .list('trail', {
          page_size: 50,
          order: 'name',
        })
        .then((res) => {
          this.trailsFromButter = res.data.data;
          this.trailsFromButter.forEach((tr) => {
            const trail = {};
            trail.name = tr.fields.name;
            trail.summary = tr.fields.summary;
            trail.description = tr.fields.description;
            trail.image = tr.fields.image;
            trail.slug = tr.slug;
            this.trails.push(trail);
          });
        })
        .catch((res) => {
          console.log(res);
        });
    },
  },
  async mounted() {
    await this.getPages();
  },
})
class Trails extends Vue {}

export default Trails;
</script>

<style scoped lang="scss">
.hero-image {
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  height: auto;
  position: relative;
  width: 100%;
}
.trails-card {
  box-shadow: 0 0 1px 0 rgba(10, 22, 70, 0.06), 0 6px 6px -1px rgba(10, 22, 70, 0.1);
  border-radius: 8px;
  color: #173945;
  display: flex;
  flex-direction: column;
  margin-bottom: 24px;
  text-decoration: none;
  transition: all 0.3s ease-in-out;

  &:hover {
    color: #173945;
    box-shadow: 0 0 1px 0 rgba(10, 22, 70, 0.06), 0 16px 26px -1px rgba(10, 22, 70, 0.1);
    transition: all 0.3s ease-in-out;
  }
}

.trails-figure {
  border-radius: 8px 8px 0 0;
  height: 200px;
  margin: 0;
  overflow: hidden;
  padding: 0;
  width: 100%;
}
.img-fluid {
  width: 100%;
}
.card-trails {
  background-color: white;
  border-radius: 0 0 8px 8px;
  padding: 20px;
  color: #173945;
  text-align: left;
}

.card-trails span {
  font-size: 16px;
  line-height: 20px;
  max-height: 80px;
  overflow: hidden;
  display: block;
}

.margin-trails a {
  margin-right: 15px;
  margin-left: 15px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
